import React from "react";
import { useLocation } from "react-router-dom";
import { strings } from "investira.sdk";

/**
 * Converte a query string atual da rota em objeto simples.
 *
 * @description
 * Este hook realiza as seguintes operações:
 * 1. Lê o campo `search` da rota atual
 * 2. Converte a query string em objeto via `strings.querystringToObject`
 * 3. Memoriza o resultado enquanto a query string não mudar
 *
 * @returns {Object} Objeto com os parâmetros presentes na URL atual
 */
function useSearch() {
  const { search } = useLocation();
  return React.useMemo(() => strings.querystringToObject(search), [search]);
}

export default useSearch;
